import { gql } from '@apollo/client';

export const GET_CATEGORIES_TIER2S = gql`
  query GetCategoriesTier2S($where: categories_tier2WhereInput) {
    categoriesTier2S(where: $where) {
      name
      sys_name
      isActive
      imageUrl
    }
  }
`;

export type CategoryTier2 = {
  name: string;
  sys_name: string;
  isActive: boolean;
  imageUrl?: string | null;
};

export type GetCategoriesTier2SQueryResult = {
  categoriesTier2S: CategoryTier2[];
};

export type GetCategoriesTier2SQueryVariables = {
  where?: {
    categories_tier1?: {
      sys_name?: {
        equals?: string;
      };
    };
    isActive?: {
      equals?: boolean;
    };
  };
};
